module.exports = __webpack_public_path__ + "img/8.d4d45897.svg";